/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regular expression`)
};

const es_iupac_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expresión regular`)
};

const de_iupac_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regulärer Ausdruck`)
};

const nl_iupac_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reguliere expressie`)
};

const fr_iupac_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expression régulière`)
};

const it_iupac_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espressione regolare`)
};

const pt_br2_iupac_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expressão regular`)
};

const pt_iupac_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expressão regular`)
};

const ja_iupac_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正規表現`)
};

const zh_iupac_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正则表达式`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_output_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_output_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_output_label", locale)
	if (locale === "en") return en_iupac_output_label(inputs)
	if (locale === "es") return es_iupac_output_label(inputs)
	if (locale === "de") return de_iupac_output_label(inputs)
	if (locale === "nl") return nl_iupac_output_label(inputs)
	if (locale === "fr") return fr_iupac_output_label(inputs)
	if (locale === "it") return it_iupac_output_label(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_output_label(inputs)
	if (locale === "pt") return pt_iupac_output_label(inputs)
	if (locale === "ja") return ja_iupac_output_label(inputs)
	return zh_iupac_output_label(inputs)
};